import {PropsWithChildren} from "react";
import {CreateLiveEventProvider} from ".";

export function CreateLiveEventContextWrapper({children}: PropsWithChildren) {
  return <CreateLiveEventProvider>{children}</CreateLiveEventProvider>;
}
